import { render, staticRenderFns } from "./SelfInfo.vue?vue&type=template&id=4505234f&"
import script from "./SelfInfo.vue?vue&type=script&lang=js&"
export * from "./SelfInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports